<template>
  <section class="mt-5">
    <div
      style="word-break: normal"
      class="flex items-start gap-x-4 border border-yellow-8 rounded-md py-1.5 px-1 bg-yellow-7"
    >
      <warning-icon class="w-5 h-6" />
      <p class="text-13px font-normal text-yellow-8">
        Please ensure you use the correct reference when making a deposit.
      </p>
    </div>
    <div class="mt-5">
      <copy-all :details="wireTransferDetails" />
      <div class="grid grid-cols-12 mb-4">
        <p class="col-span-6 text-13px text-fg-muted font-normal">
          Amount to be deposited:
        </p>
        <p class="col-span-5 text-13px font-bold text-fg-muted">
          {{ parseMoneyAll(depositedAmount, depositedCurrency) }}
        </p>
      </div>
      <div class="grid grid-cols-12 mb-4">
        <p class="col-span-6 text-13px text-fg-muted font-normal">
          Destination:
        </p>
        <div
          class="col-span-6 text-13px font-bold text-fg-muted flex items-center gap-x-2"
          style="word-break: normal"
        >
          <currency-icons :currency="getCurrencyCountry(depositedCurrency)" />
          <p>
            {{ depositedCurrency }}
            Virtual Account
          </p>
        </div>
      </div>
      <div>
        <div v-for="(item, index) in bankDetails" :key="index">
          <div v-if="item.value" class="grid grid-cols-12 mb-4">
            <p class="col-span-6 text-13px text-fg-muted font-normal">
              {{ item.key }}:
            </p>
            <p class="col-span-5 text-13px font-bold text-fg-muted">
              {{ item.value }}
            </p>
            <div
              v-if="item.copy"
              class="col-span-1 cursor-pointer"
              v-clipboard:copy="item.value"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <copy-icon />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-10 w-full flex items-center gap-x-4 text-sm font-normal">
      <div
        class="w-1/2 bg-white border border-primary text-primary py-3.5 rounded-md cursor-pointer text-center"
        @click="generatePdf"
      >
        Download
      </div>
      <div
        class="w-1/2 bg-primary text-white py-3.5 rounded-md cursor-pointer text-center"
        @click="handleClose"
      >
        Done
      </div>
    </div>
    <vuehtml2pdf
      :manual-pagination="true"
      :filename="fileName"
      :pdf-quality="2"
      pdf-format="a4"
      pdf-content-width="800px"
      :enable-download="true"
      ref="DownloadComp"
      :show-layout="false"
    >
      <section slot="pdf-content">
        <deposit-details
          :terminalWireTransferDetails="wireTransferDetails"
          type="deposit"
        />
      </section>
    </vuehtml2pdf>
  </section>
</template>
<script>
import { GetCurrencyCountry, ParseMoneyAll } from '@/utils/helpers.js'
import pendingDeposit from '@/mixins/pendingDeposit.js'
export default {
  mixins: [pendingDeposit],
  components: {
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue'),
    WarningIcon: () => import('@/assets/icons/WarningIcon.vue'),
    DepositDetails: () => import('@/components/deposit/DepositDetails.vue'),
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue')
  },
  methods: {
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    handleClose () {
      this.$emit('handleClose')
      this.$router.push({ name: 'transactions' })
    },
    generatePdf () {
      this.$refs.DownloadComp.generatePdf()
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    }
  },
  computed: {
    bankDetails () {
      const data = [
        {
          key: 'Payment Method',
          value: 'Bank Deposit'
        },
        {
          key: 'Bank Name',
          value: this.wireTransferDetails?.creditTo,
          copy: true
        },
        {
          key: 'Account Name',
          value: this.wireTransferDetails?.accountName,
          copy: true
        },
        {
          key: 'IBAN',
          value: this.wireTransferDetails?.iban,
          copy: true
        },
        {
          key: 'Swift Code',
          value: this.wireTransferDetails?.swiftCode,
          copy: true
        },
        {
          key: 'Sort Code',
          value: this.wireTransferDetails?.sortCode,
          copy: true
        }
      ]
      return data
    },
    selectedAccountDetails () {
      return this.$store.state.transactions.selectedDepositAccountDetails
    },
    depositedAmountDetails () {
      return this.$store.state?.transactions?.depositedAmountDetails || {}
    },
    depositedAmount () {
      return (
        this.transactionDetails?.depositedAmount?.amount ||
        this.transactionDetails?.depositedAmount ||
        this.depositedAmountDetails?.amount ||
        ''
      )
    },
    depositedCurrency () {
      return (
        this.transactionDetails?.depositedAmount?.currency ||
        this.transactionDetails?.depositedCurrency ||
        this.depositedAmountDetails?.currency ||
        ''
      )
    },
    transactionDetails () {
      return this.$store.state.transactions.transactionDetails
    },
    wireTransferDetails () {
      return this.$store.state.transactions.depositInfo.wireInstruction
    },
    fileName () {
      return `${process.env.VUE_APP_TENANT_TITLE} Deposit Details`
    }
  }
}
</script>
